import React from "react";
import { Apple, Play } from "lucide-react";
import { APP_LINKS } from "../mock";

// Reusable App Store + Google Play badges (SVG-styled, no external images)
const StoreBadges = ({ size = "md", theme = "dark", onClickTrack }) => {
  const dims =
    size === "lg"
      ? { h: "h-[58px]", px: "px-5", title: "text-[11px]", store: "text-lg" }
      : size === "sm"
      ? { h: "h-[44px]", px: "px-3.5", title: "text-[9px]", store: "text-sm" }
      : { h: "h-[52px]", px: "px-4", title: "text-[10px]", store: "text-base" };

  const base =
    theme === "light"
      ? "bg-white text-emerald-950 border border-emerald-950/10 hover:bg-emerald-50"
      : "bg-emerald-950 text-white hover:bg-emerald-900";

  const handle = (platform) => () => {
    try { onClickTrack && onClickTrack(platform); } catch (e) { /* noop */ }
  };

  return (
    <div className="flex flex-wrap items-center gap-3">
      <a
        href={APP_LINKS.ios}
        target="_blank"
        rel="noreferrer"
        onClick={handle("ios")}
        className={`shine flex items-center gap-3 rounded-2xl ${dims.h} ${dims.px} ${base} transition-transform hover:-translate-y-0.5 shadow-sm`}
      >
        <Apple className="w-6 h-6" strokeWidth={2} />
        <div className="leading-tight text-left">
          <div className={`${dims.title} opacity-70 uppercase tracking-wider`}>Download on the</div>
          <div className={`${dims.store} font-semibold font-display`}>App Store</div>
        </div>
      </a>

      <a
        href={APP_LINKS.android}
        target="_blank"
        rel="noreferrer"
        onClick={handle("android")}
        className={`shine flex items-center gap-3 rounded-2xl ${dims.h} ${dims.px} ${base} transition-transform hover:-translate-y-0.5 shadow-sm`}
      >
        <Play className="w-6 h-6 fill-current" strokeWidth={2} />
        <div className="leading-tight text-left">
          <div className={`${dims.title} opacity-70 uppercase tracking-wider`}>Get it on</div>
          <div className={`${dims.store} font-semibold font-display`}>Google Play</div>
        </div>
      </a>
    </div>
  );
};

export default StoreBadges;
